import React, { useEffect, useRef, useState } from 'react';
import '../../../styles/mainContents.css'
import '../../../styles/navbar.css'
//import { submitConsignmentsCustomerInventoryReplenish, setCustomerInventoryReplenishChange } from '../../../redux/actions/consignmentsPostActions';
import { submitConsignmentsCustomerInventoryReplenish } from '../../../redux/actions/consignmentsPostActions';
import { connect } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import { createTheme, ThemeProvider  } from '@mui/material/styles'
import { Padding } from '@mui/icons-material';
import { BaseButtonStyle } from '../../../styles/CommonStyling';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import NumberSpinner from '../../shared/NumberSpinner';

function InventoryCountReplenish(props) {


  const { consignmentsCustInventoryCountReplenishDetailState, consignmentsCustomerInventoryCountNoReplenishCustState, consignmentsCustInventoryReplenishChangeState, consignmentsCustInventoryCountReplenishState, submitConsignmentsCustomerInventoryReplenish, setCustomerInventoryReplenishChange, authreducerState } = props;

  const [ countCommentState, setCountCommentState ] = useState({
    COMMENT: '',                              
  });  

  const [ replenishPoState, setReplenishPoState ] = useState({
    PO: '',                              
  }); 

  const columnsOptions = (colName='', inputType='number',filterEnabled=true,displayType=true, downloadType=true) => {
    var options = {};
    let maxValue = 1000;
    
    
    colName === 'REPLENISH_QTY' ?
      options = {
        filter: filterEnabled,
        sort: true,
        download: downloadType,
        display: displayType,
        responsive: 'standard',
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: "pre-wrap",
            position: "sticky",
            top: '0px',
            zIndex: 101,            
          }
        }),  

        customBodyRenderLite: (dataIndex, rowIndex) => {

          const total_onhand_at_locs  =  consignmentsCustInventoryCountReplenishDetailState[consignmentsCustInventoryCountReplenishState[dataIndex]['PRDID']].reduce((accumulator, current_item) => {
            return accumulator + current_item.ONHAND;
          }, 0);

          return (
            <span>  
              <React.Fragment>              
                {consignmentsCustInventoryCountReplenishState[dataIndex][colName]} 
                {
                  total_onhand_at_locs <= 0 ? (
                    <span style={{'color': 'red', 'paddingLeft':'1em'}}>
                      {total_onhand_at_locs} ONHAND
                    </span>
                  ) 
                  : ''          
                  // consignmentsCustInventoryCountReplenishDetailState[consignmentsCustInventoryCountReplenishState[dataIndex]['PRDID']][0]                  
                }
              </React.Fragment>                                                                                  
            </span>
          )       
        }
      }
    :
      options = {
        filter: filterEnabled,
        sort: true,
        download: downloadType,
        display: displayType,
        responsive: 'standard',
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: "pre-wrap",
            position: "sticky",
            top: '0px',
            zIndex: 101,            
          }
        }),  

        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <span>  
              <React.Fragment>              
                {consignmentsCustInventoryCountReplenishState[dataIndex][colName]}  
              </React.Fragment>                                                                                  
            </span>
          )       
        },       
      } 
    
    return options;
  }

  const columns = [  
    {
      name: "PRDID",
      label: "Prdid",
      options: {
        filter: false,
        display: "excluded", 
        download:false,
      },
      
    },     
    {
      name: "LINE",
      label: "line",
      options: columnsOptions('LINE', 'text', true, 'excluded', true)
    },
    {
      name: "PARTNO",
      label: "partno",
      options: columnsOptions('PARTNO', 'text', false, 'excluded', true),
    },
    {
      name: "CAT",
      label: "cat",
      options: columnsOptions('CAT', 'text', false, 'excluded', true),
    },    
    {
      name: "LINE_PARTNO",
      label: "LINE\nPARTNO",
      options: columnsOptions('LINE_PARTNO', 'text', false, true, false)
    },    
    {
      name: "DESCRIPTION",
      label: "DESC",
      options: columnsOptions('DESCRIPTION', 'text', false, true, true),
    },              
    {
      name: "REPLENISH_QTY",
      label: "REPLENISH\nQTY",
      options: columnsOptions('REPLENISH_QTY', 'text', false, true, true),
    },       
    // {
    //   name: "USER_INPUT",
    //   label: "REPLENISH",
    //   options: columnsOptions('USER_INPUT', 'checkbox', false, true),
    // },  
       
  ]



  const options = {
    filterType: "checkbox",
    fixedHeader: true,
    selectableRows: 'none',
    //responsive: "standard",
    print: false,
    responsive: 'simple',
    tableBodyHeight: "400px",
    searchAlwaysOpen: true,  
    onRowClick: (rowData, rowMeta) => {
      //console.log({rowData, rowMeta});
    },
    onChangePage (currentPage) {
      // console.log({currentPage});
     
    },
    rowsPerPage: 200,
    expandableRows: true,      
    expandableRowsOnClick: true,     
    renderExpandableRow: (rowData, rowMeta) => {
      console.log('rowData',rowData)
      console.log('rowData[0]',rowData[0])
      console.log('consignmentsCustInventoryCountReplenishDetailState[rowData[0]]',consignmentsCustInventoryCountReplenishDetailState[rowData[0]])

      
      const colSpan = rowData.length + 1;
      return (
        <TableRow key={'renderExpandableRowKey' + rowData[0]} >
          <TableCell colSpan={colSpan}>
            <Table>
              <TableHead>
                <TableRow key={'renderExpandableRowKey' + rowData[0] + '_head'} >
                  <TableCell align="right">
                    ORDERING_LOC
                  </TableCell>
                  <TableCell align="right">
                    ONHAND
                  </TableCell>  
                  <TableCell align="right">
                    CHANGE_REPLENISH
                  </TableCell>                                       
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  consignmentsCustInventoryCountReplenishDetailState[rowData[0]].map((row, index) => (
                    <TableRow key={'renderExpandableRowKey' + rowData[0] + '_bodyKey' + row.ORDERING_LOC }>
                      <TableCell align="right">
                        {JSON.stringify(row.ORDERING_LOC)}                       
                      </TableCell>
                      <TableCell align="right">
                        {JSON.stringify(row.ONHAND)}
                      </TableCell>  
                      <TableCell align="right">
                        <div>
                          {row.LOC_REPLENISH_QTY}
                        </div>
                        {/* <NumberSpinner
                          id={"numberspinner_" + row.ORDERING_LOC}
                          key={"numberspinner_" + row.ORDERING_LOC + "_" + row.LOC_REPLENISH_QTY}
                          name={"numberspinner_qty"}
                          label=""
                          min={0}
                          max={row.ONHAND}
                          size="medium"
                          // defaultValue={row.LOC_REPLENISH_QTY} 
                          defaultValue={row.LOC_REPLENISH_QTY ?? 0} 
                          onValueChange={(value, eventDetails) => {
                            // consignmentsCustInventoryCountReplenishDetailState

                            console.log('InventoryCountReplenish onValueChange value:', value);
                            console.log('InventoryCountReplenish onValueChange row:', row);
                            consignmentsCustInventoryCountReplenishDetailState[rowData[0]][index]['LOC_REPLENISH_QTY'] = value;
                            console.log('InventoryCountReplenish onValueChange now :', consignmentsCustInventoryCountReplenishDetailState[rowData[0]][index]);
                          }} 
                          error
                        /> */}
                      </TableCell>                                          
                    </TableRow>
                  ))
                }
              </TableBody>
            </Table>
          </TableCell>

        </TableRow>

      );
    },     
  };  

  const replenishSubmitBtn = () => {
    return (

      <BaseButtonStyle variant="contained" onClick={(e)=>
        {
          if( Object.keys(consignmentsCustInventoryCountReplenishState).length > 0 && Object.keys(replenishPoState).length > 0 ){
            if (window.confirm('Click Ok to submit Replenishment or Cancel to not submit replenishment.')) 
            {              
              submitConsignmentsCustomerInventoryReplenish(authreducerState.user.userid, consignmentsCustInventoryCountReplenishState[0]['CUSTID'], countCommentState['COMMENT'], replenishPoState['PO'], consignmentsCustInventoryCountReplenishDetailState) 
              window.scrollTo({ top: 0, behavior: 'smooth' });              
            } 
            else 
            {
              console.log('Cancelled - Replenishment was not saved.');
            } 
          }
          else{
            alert('No replenishment entered');
            console.log('No replenishment entered');
          }  
        }
        }>Create Replenishment Order
      </BaseButtonStyle>


    )    
  }

  const getMuiTheme = () =>
  createTheme({
    overrides: {
      MUIDataTableToolbar: {
        actions: {
          display: "flex",
          flex: "initial",
          // move all icons to the right
          "& > span, & > button": {
            order: 99
          },
          // target the custom toolbar icon
          "& > span:last-child, & > button:last-child": {
            order: 1
          },
          // target any icon
          "& > span:nth-child(4), & > button:nth-child(4)": {
            order: 2
          }
        }
      }
    }
  });

  return (

    <div>
        <div>   
          <div id='consignmentsInventoryCountTblId' className='detailTblClass'>

            { consignmentsCustInventoryCountReplenishState !== undefined && 
              consignmentsCustInventoryCountReplenishState !== null ?
              consignmentsCustInventoryCountReplenishState.length > 0 ?                
                <div>

                  <table id='inventoryCountTblHeader'>
                    <thead>
                      <tr>
                        <th colSpan='4'>Customer Consignments Resolve Replenishment</th>
                      </tr>
                    </thead>
                    <tbody>                                
                          <React.Fragment>
                            <tr>
                              <td>Customer#:</td>
                              <td>
                                {consignmentsCustInventoryCountReplenishState[0]['CUSTNO']}
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                {consignmentsCustInventoryCountReplenishState[0]['CUSTNAME']} <br/>
                                {consignmentsCustInventoryCountReplenishState[0]['ADDR1']} <br/>
                                {consignmentsCustInventoryCountReplenishState[0]['ADDR2']} {consignmentsCustInventoryCountReplenishState[0]['ADDR2'] !== '' ? (<React.Fragment> <br/> </React.Fragment>) : ''}
                                {consignmentsCustInventoryCountReplenishState[0]['CITY']} {consignmentsCustInventoryCountReplenishState[0]['STATE']} {consignmentsCustInventoryCountReplenishState[0]['ZIP']}
                              </td>
                            </tr>
                          </React.Fragment>                                                         
                    </tbody>
                  </table>

                  <ThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable             
                      data={consignmentsCustInventoryCountReplenishState}
                      columns={columns}
                      options={options}
                    />
                  </ThemeProvider>

                  <table style={{'marginTop':'2em', 'marginLeft': '1em'}}>
                    <thead>                      
                    </thead>
                    <tbody>                    
                      <tr>
                        <td style={{'textAlign':'end'}}>PO:</td>
                        <td>
                          <input type='text' id="iAddReplenishPo" name="nAddReplenishPo" maxLength="100" onInput={ e => setReplenishPoState({PO: e.target.value})} ></input>
                        </td>
                      </tr>
                      <tr>
                        <td>Comments:</td>
                        <td>
                          <input type='text' id="iAddComment" name="nAddComment" maxLength="100" onInput={ e => setCountCommentState({COMMENT: e.target.value})} ></input>                                          
                        </td>
                      </tr>  
                    </tbody>                  
                  </table>
                  {/* <div style={{'marginTop':'2em'}}>
                    PO: </div>

                  <div style={{'marginTop':'0.5em'}}>
                    Comments </div> */}

                  <div style={{'marginTop':'1em','marginBottom':'2em'}}>

                    {/* <button type='button' id='backToOrders' onClick={()=>{
                      window.location.href='/'
                    }}>Back</button> */}

                    <BaseButtonStyle variant="outlined" onClick={() => {
                      if (window.confirm('Click Ok to confirm No Replenishment order needed.')) 
                      {              
                        window.location.href='/'            
                      } 
                    }}>No Replenishment
                    </BaseButtonStyle>

                    {/* <button type='button' id='noReplenishmentBtn' onClick={()=>{
                      if (window.confirm('Click Ok to confirm No Replenishment order needed.')) 
                      {              
                        window.location.href='/'            
                      }                   
                      
                    }}>No Replenishment</button>                */}

                    <span style={{'marginLeft':'3em'}}> 
                      { 
                        (authreducerState.user.role_name === undefined) ? "" :                    
                          (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR') ? "" :
                          replenishSubmitBtn()
                      } 
                    </span>

                  </div>
                </div>


                : ''
              : ''
          
            }

            { consignmentsCustomerInventoryCountNoReplenishCustState !== undefined && 
              consignmentsCustomerInventoryCountNoReplenishCustState !== null ?
              consignmentsCustomerInventoryCountNoReplenishCustState.length > 0 ? 

                <div>
                  <table id='inventoryCountTblHeader'>
                    <thead>
                      <tr>
                        <th colSpan='4'>Customer Consignments No Available Replenishment For Counted Partnos</th>
                      </tr>
                    </thead>
                    <tbody>                                
                          <React.Fragment>
                            <tr>
                              <td>Customer#:</td>
                              <td>
                                {consignmentsCustomerInventoryCountNoReplenishCustState[0]['CUSTNO']}
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                {consignmentsCustomerInventoryCountNoReplenishCustState[0]['CUSTNAME']} <br/>
                                {consignmentsCustomerInventoryCountNoReplenishCustState[0]['ADDR1']} <br/>
                                {consignmentsCustomerInventoryCountNoReplenishCustState[0]['ADDR2']} {consignmentsCustomerInventoryCountNoReplenishCustState[0]['ADDR2'] !== '' ? (<React.Fragment> <br/> </React.Fragment>) : ''}
                                {consignmentsCustomerInventoryCountNoReplenishCustState[0]['CITY']} {consignmentsCustomerInventoryCountNoReplenishCustState[0]['STATE']} {consignmentsCustomerInventoryCountNoReplenishCustState[0]['ZIP']}
                              </td>
                            </tr>
                          </React.Fragment>                                                         
                    </tbody>
                  </table>

                  <div style={{'marginTop':'1em','marginBottom':'2em'}}>

                    <BaseButtonStyle variant="outlined" onClick={() => {
                      window.location.href='/'  
                    }}>No Replenishment
                    </BaseButtonStyle>

                    {/* <button type='button' id='noReplenishmentBtn' onClick={()=>{
                      window.location.href='/'
                    }}>No Replenishment</button> */}

                  </div>                                    
                </div>

                : ''
              : ''
            
            }
          </div>


        </div>
    </div>

  );
}



const mapStateToProps = (state) => {

 return {
  authreducerState: state.authreducer,

  consignmentsCustInventoryCountReplenishState: state.consignmentsPostReducer['items_fetchConsignmentsCustomerInventoryCountReplenish'],
  consignmentsCustInventoryReplenishChangeState: state.consignmentsPostReducer['items_consignmentsCustomerInventoryReplenishChange'],
  consignmentsCustomerInventoryCountNoReplenishCustState: state.consignmentsPostReducer['items_fetchConsignmentsCustomerInventoryCountNoReplenishCust'],
  consignmentsCustInventoryCountReplenishDetailState: state.consignmentsPostReducer['items_fetchConsignmentsCustomerInventoryCountReplenishDetail'],
  
 }

};

const mapDispatchToProps = (dispatch) => {
  return {
    //NOT NEEDED ATM
    // setCustomerInventoryReplenishChange: (rowState) => {
    //   dispatch(setCustomerInventoryReplenishChange(rowState));
    // },  
    submitConsignmentsCustomerInventoryReplenish: (userid, custid, comments, po, rowState) => {
      dispatch(submitConsignmentsCustomerInventoryReplenish(userid, custid, comments, po, rowState));
    },  
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InventoryCountReplenish);